import React, { useState } from 'react';

const PasswordGate = ({ children }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check if already authenticated in session storage
    return sessionStorage.getItem('paria_authenticated') === 'true';
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === '12321') {
      setIsAuthenticated(true);
      sessionStorage.setItem('paria_authenticated', 'true');
      setError('');
      setPassword('');
    } else {
      setError('Incorrect invite code. Please try again.');
      setPassword('');
    }
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '25px',
        boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '64px',
          marginBottom: '20px'
        }}>
          🔒
        </div>
        <h1 style={{
          fontSize: '36px',
          fontWeight: '800',
          color: '#DD2E44',
          marginBottom: '15px'
        }}>
          Private Beta Access
        </h1>
        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '30px'
        }}>
          Enter your invite code to access the dashboard
        </p>
        
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError('');
            }}
            placeholder="Enter invite code"
            style={{
              width: '100%',
              padding: '18px',
              borderRadius: '20px',
              border: error ? '2px solid #DD2E44' : '2px solid #DD2E44',
              fontSize: '18px',
              fontFamily: "'Nunito', sans-serif",
              outline: 'none',
              marginBottom: '15px',
              textAlign: 'center',
              letterSpacing: '4px',
              fontWeight: '600'
            }}
            autoFocus
          />
          
          {error && (
            <div style={{
              color: '#DD2E44',
              fontSize: '14px',
              marginBottom: '20px',
              fontWeight: '600'
            }}>
              {error}
            </div>
          )}
          
          <button
            type="submit"
            style={{
              width: '100%',
              backgroundColor: '#DD2E44',
              color: 'white',
              padding: '18px',
              borderRadius: '20px',
              border: 'none',
              fontSize: '18px',
              fontWeight: '700',
              cursor: 'pointer',
              boxShadow: '0 6px 20px rgba(221, 46, 68, 0.3)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 6px 20px rgba(221, 46, 68, 0.3)';
            }}
          >
            Access Dashboard →
          </button>
        </form>

        <div style={{
          marginTop: '30px',
          padding: '20px',
          backgroundColor: '#FFF5F7',
          borderRadius: '15px',
          fontSize: '14px',
          color: '#666'
        }}>
          <p style={{ margin: 0 }}>
            Don't have an invite code? <br />
            <a
              href="/contact"
              style={{
                color: '#DD2E44',
                fontWeight: '600',
                textDecoration: 'none'
              }}
            >
              Contact us
            </a> to request access.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PasswordGate;